// DayPasses action types

const dayPassesActionTypes = {
  SET_DAYPASSES: 'SET_DAYPASSES',

  SET_DAYPASSES_AVAILABLE_DATES: 'SET_DAYPASSES_AVAILABLE_DATES',
  UPDATE_DAYPASSES_FETCHING: 'UPDATE_DAYPASSES_FETCHING'
};

export default dayPassesActionTypes;
